import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/Auth";
import { Footer, Header, Spinner } from "@/components/Layout";
import { AreaLayout } from "@/components/AreaLayout";
import Home from "@/pages/Home";
import Vetrina from "@/pages/Vetrina";
import Checkout from "@/pages/Checkout";
import OrdineEsito from "@/pages/OrdineEsito";
import VerificaSaldo from "@/pages/VerificaSaldo";
import Login from "@/pages/Login";
import Registrati from "@/pages/Registrati";
import RegistratiOperatore from "@/pages/RegistratiOperatore";
import { VerificaEmail, PasswordDimenticata, ReimpostaPassword } from "@/pages/AuthExtra";
import Account from "@/pages/Account";
import OperatoreDashboard from "@/pages/operatore/Dashboard";
import EsitoPiano from "@/pages/operatore/EsitoPiano";
import AdminDashboard from "@/pages/admin/Dashboard";

const AZIENDE = new URL(process.env.REACT_APP_AZIENDE_URL);
const SOTTODOMINIO = window.location.hostname.startsWith("aziende.");

const Protected = ({ ruolo, children, login = "/accedi" }) => {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  if (!user || user.ruolo !== ruolo) return <Navigate to={login} replace />;
  return children;
};

const RedirectSottodominio = () => {
  const loc = useLocation();
  useEffect(() => {
    if (loc.pathname.startsWith("/aziende") && AZIENDE.host !== window.location.host) {
      window.location.replace(`${AZIENDE.origin}${loc.pathname}${loc.search}`);
    }
  }, [loc]);
  return null;
};

const RedirectArea = () => {
  const loc = useLocation();
  return <Navigate to={`/aziende${loc.pathname === "/" ? "" : loc.pathname}${loc.search}`} replace />;
};

const AreaAziende = () => (
  <AreaLayout>
    <Routes>
      <Route index element={<Navigate to="pannello" replace />} />
      <Route path="accedi" element={<Login area="aziende" />} />
      <Route path="registrazione" element={<RegistratiOperatore />} />
      <Route path="verifica-email" element={<VerificaEmail base="/aziende" />} />
      <Route path="password-dimenticata" element={<PasswordDimenticata />} />
      <Route path="reimposta-password" element={<ReimpostaPassword base="/aziende" />} />
      <Route path="piano/esito" element={<EsitoPiano />} />
      <Route path="pannello" element={<Protected ruolo="operatore" login="/aziende/accedi"><OperatoreDashboard /></Protected>} />
      <Route path="*" element={<Navigate to="/aziende/pannello" replace />} />
    </Routes>
  </AreaLayout>
);

const SitoPubblico = () => (
  <div className="min-h-screen flex flex-col">
    <Header />
    <div className="flex-1">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/vetrina/:id" element={<Vetrina />} />
        <Route path="/checkout/:id" element={<Checkout />} />
        <Route path="/ordine/:id" element={<OrdineEsito />} />
        <Route path="/verifica-saldo" element={<VerificaSaldo />} />
        <Route path="/accedi" element={<Login />} />
        <Route path="/registrati" element={<Registrati />} />
        <Route path="/verifica-email" element={<VerificaEmail />} />
        <Route path="/password-dimenticata" element={<PasswordDimenticata />} />
        <Route path="/reimposta-password" element={<ReimpostaPassword />} />
        <Route path="/account" element={<Protected ruolo="acquirente"><Account /></Protected>} />
        <Route path="/admin" element={<Protected ruolo="admin"><AdminDashboard /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
    <Footer />
  </div>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <RedirectSottodominio />
        <Routes>
          <Route path="/aziende/*" element={<AreaAziende />} />
          <Route path="*" element={SOTTODOMINIO ? <RedirectArea /> : <SitoPubblico />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
